import React, { useEffect, useRef, useState } from 'react'
import InputMask from 'react-input-mask'
import { isValid } from 'date-fns'
import Icon from '../../Icon/Icon'
import DatePicker from '../../DatePicker/DatePicker'
import { usePopUp } from '../../../hooks/usePopUp'
import { formatDateAsDayMonthYear } from '../../../utils/date/dateFormat'
import { convertDateFromString } from '../../../utils/date/convertDateFromString'
import * as FIELD_MASK from '../../../utils/newforms/fieldMasks'
import './Date.sass'

const COMPLETE_DATE_RE = /^([0-9]){2}\.([0-9]){2}\.([0-9]){4}$/

const parseDateValue = (value) => {
  if (!value || typeof value !== 'string' || !COMPLETE_DATE_RE.test(value.trim())) return null
  const date = convertDateFromString(value.trim())
  return isValid(date) ? date : null
}

const formatDateValue = (date) => {
  if (!date || !isValid(date)) return ''
  return formatDateAsDayMonthYear({ seconds: date.getTime() / 1000 })
}

function DateField({ fieldClass, lockIcon, iconClasses, ...props }) {
  const fieldRef = useRef()
  const ddbRef = useRef()
  const [showPopUp, setShowPopUp] = usePopUp(fieldRef, ddbRef)
  const [input, setInput] = useState(props.value || '')

  if (input.match(/\d+/)) {
    fieldClass.push('Field_with_value')
  }

  useEffect(() => {
    setInput(props.value || '')
  }, [props.value])

  const onInputChanged = (e) => {
    const { value } = e.target
    setInput(value)
    props.changed({ target: { value } })
  }

  const onPickerChange = (date) => {
    const nextValue = formatDateValue(date)
    setInput(nextValue)
    props.changed({ target: { value: nextValue } })
    setShowPopUp(false)
  }

  const selectedDate = parseDateValue(props.value)

  return (
    <div className={fieldClass.join(' ')}>
      <span className="Field-Icon">
        <Icon name="calendar-alt" />
      </span>
      <InputMask
        mask={FIELD_MASK.DATE}
        maskChar={null}
        onChange={onInputChanged}
        value={input}
        disabled={props.isChangable === false}
      >
        {(inputProps) => (
          <input ref={fieldRef} {...inputProps} type={props.config.type} placeholder={props.config.placeholder} />
        )}
      </InputMask>
      {props.config.icon || lockIcon ? (
        <span
          onClick={props.config.useDropValueButton ? props.dropValue : props.config.iconFunc}
          className={iconClasses.join(' ')}
        >
          <Icon name={props.config.icon || lockIcon} size={props.config.iconSize && props.config.iconSize} />
        </span>
      ) : null}
      {props.config.marker ? (
        <span className="Field-Marker">
          <Icon name={props.config.marker} />
        </span>
      ) : null}
      <span className="Field-Bar" />
      <label>{props.config.label}</label>
      {props.showErrors && props.error ? <div className="Field-Error">{props.error}</div> : null}
      {showPopUp && props.isChangable !== false && (
        <div ref={ddbRef} className="TaskDatePicker">
          <div className="TaskDatePicker-Container">
            <DatePicker disabledKeyboardNavigation selected={selectedDate} onChange={onPickerChange} />
          </div>
        </div>
      )}
    </div>
  )
}

export default DateField
